export default "__VITE_ASSET__m6rkAAfm__"